/**
 * Datadog RUM Ad Tracking Initialization
 *
 * This module extends the base Datadog RUM initialization with ad-specific functionality.
 * It ensures that window.DD_RUM is available for the consumerweb-ads package to send ad events.
 *
 * Key features:
 * - Exposes both window.DD_RUM and window.__datadogRum for ad compatibility
 * - Replays any queued actions that occurred before initialization
 * - Sets up mock DD_RUM in development for ad testing
 *
 * @fileoverview Datadog RUM ad tracking extensions
 */

import { datadogRum } from '@datadog/browser-rum'
import { replayQueuedActions } from './datadogPolyfill'

// Extend window interface for DD_RUM
declare global {
  interface Window {
    DD_RUM?: any
    __datadogRum?: any
  }
}

if (!APP_DEVELOPMENT) {
  // In production, expose the initialized datadogRum for consumerweb-ads package
  window.DD_RUM = datadogRum
  window.__datadogRum = datadogRum

  // Replay any actions that were queued before initialization
  replayQueuedActions()
} else {
  // In development mode, set up a mock DD_RUM for consumerweb-ads compatibility
  const mockDatadog = {
    addAction: () => {}, // No-op in development
    addError: () => {},
    addTiming: () => {}
  }

  window.DD_RUM = mockDatadog
  window.__datadogRum = mockDatadog

  // Replay any queued actions (will be no-ops)
  replayQueuedActions()
}
